/**
 * Created by zhengyf on 2017/9/27.
 *
 * params:
 *  popularStore: {list: [], hid: ''} 供应商列表
 *  topBoxWidth: number 供应商列表容器宽度
 */

;(function () {
    topSupplierCtrl.$inject = ['COUNTRYS'];
    angular
        .module('DSSXAPP')
        .component('topSupplier', {
            template:'<div class="aliIndex-supplier top-supplier-wrap" ng-show="vm.d.productList.length"><div class="t-s-title c-b"><h2 class="f-l"><a href="javascript:;">TOP SELECTED SUPPLIERS</a></h2><div class="sub-title f-l"></div><div class="label"></div></div><div class="t-s-content"><div class="t-s-product-wrapper"><div class="t-s-product-list-box" id="t-s-product-list-box"><div class="t-s-product-list c-b" ng-style="vm.d.pListStyle"><div class="t-s-product-col-item" ng-repeat="pItem in vm.d.productList"><div class="supplier-item"><div class="top"><a target="_blank" ng-href="{{pItem.storeUrl}}"><div class="supplier-item-title util-ellipsis"><div ng-bind="pItem.title" class="a-title" ng-attr-title="{{pItem.title}}"></div></div><div class="icon-list"><img src="images/aliIndex/year.png" class="icon-1"> <span class="gs-years-wrapper"><span ng-bind="pItem.years"></span> <span>YRS</span></span> <img src="images/aliIndex/trade.png" class="icon-1"></div><div class="trade-info"><div class="order"><div class="label">orders</div><div class="value" ng-bind="pItem.orders"></div></div><div class="split"></div><div class="export-country"><div class="label">Exported to countries like</div><div class="value"><span ng-repeat="c in pItem.exportCountry track by $index"><span ng-bind="c"></span> <span ng-show="$index !== 2">，</span></span></div></div></div></a></div><div class="bottom"><div class="offer-list c-b"><div class="offer-list-w1" ng-class="{\'d-ib\': pItem.imgs.length <= 2}" ng-repeat="pic in pItem.imgs track by pic.id"><div class="offer-wrapper"><div class="offer-box"><a ng-href="{{pic.prodDetailUrl}}" target="_blank"><img ng-src="{{pic.img}}"></a></div></div></div></div></div></div></div></div></div><i class="iconfont icon-back i-back" ng-click="vm.f.setPListLeft(\'prev\')" ng-class="{\'able-click\': vm.isAbleClick.prev}"></i> <i class="iconfont icon-more i-more" ng-click="vm.f.setPListLeft(\'next\')" ng-class="{\'able-click\': vm.isAbleClick.next}"></i></div></div></div>',
            bindings: {
                popularStore: '<',
                topBoxWidth: '<'
            },
            controllerAs: 'vm',
            controller: topSupplierCtrl
        });

    function topSupplierCtrl(COUNTRYS) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.d = {
            productList: [],
            pListStyle: {
                transform: 'translateX(0px)'
            },
            hid: ''
        };

        vm.f = {
            setPListLeft: setPListLeft,
            getToken: DSSX.util.getToken,
            gotoStore: gotoStore
        };

        vm.left = 0; //当前偏移量
        vm.totalLeft = 0; //总的偏移量
        vm.isAbleClick = {
            prev: false,
            next: false
        };
        var COL_WIDTH = 336; // 一列的width
        var num = 4; // 一次可见几列
        var mistakeWidth = 65; // 加上这70占满整个盒子
        var countryValueList = [];

        // ==========function==================

        function onInit() {  //70
            console.log('[topSupplierCtrl init: ]');
            handleCountryList();
        }

        function bindingsOnChanges(changes) {
            if (changes.popularStore) {
                var popularStore = angular.copy(vm.popularStore);
                var list = popularStore.list;
                vm.d.hid = popularStore.hid;
                for (var i = 0; i < list.length; i++) {
                    var product = {
                        title: list[i].cpnyName || 'Guangdong Cross-border E-commerce Training Platform Co., Ltd.',
                        years: randomNumber(10),
                        orders: list[i].orderCount,
                        exportCountry: randomThreeCountry([]),
                        imgs: handlerImgs(list[i].prods),
                        storeId: list[i].storeId,
                        storeUrl: DSSX.util.getNeedCountClickPageUrl(list[i].storeId, vm.d.hid, 'HOME_PAGE', 'shop')
                    };
                    vm.d.productList.push(product);
                }
                initProductListWidth();

            }

            if (changes.topBoxWidth) {
                var width = angular.copy(vm.topBoxWidth); //
                num = Math.floor(width / COL_WIDTH);
                mistakeWidth = width - num * COL_WIDTH;
                initProductListWidth();
            }
        }

        function handlerImgs(prods) {
            prods = prods || [];
            var result = [];
            for (var i = 0; i < prods.length; i++) {
                //result = result.concat(prods[i].imgs);

                var img = '';
                if (prods[i].imgs.length) {
                    img = prods[i].imgs[0].url || '';
                }

                var o = {
                    img: DSSX.util.safe(prods[i], 'imgs.0.url', '') + '/small',
                    id: prods[i].id,
                    prodDetailUrl: DSSX.util.getNeedCountClickPageUrl(prods[i].id, vm.d.hid, 'HOME_PAGE', 'prod')
                };
                result.push(o);
            }
            return result.slice(0, 3);
        }

        /**
         * 初始化productList的width
         */
        function initProductListWidth() {
            var list = vm.d.productList;
            var width = list.length * COL_WIDTH;
            vm.d.pListStyle.width = width + 'px'; // 轮播图的总宽度
            vm.totalLeft = width - vm.topBoxWidth;
            if (width < vm.topBoxWidth) {
                setBtnStatus(false, false);
            } else {
                setBtnStatus(false, true);
            }
        }

        /**
         * 偏移量计算
         * 1、获得盒子宽度 vm.topBoxWidth
         * 2、获得图片列表长度，计算列表总宽度 vm.d.pListStyle.width = list.length * COL_WIDTH
         * 3、计算在盒子中能放几张图片，算出不足部分宽度 mistakeWidth = vm.topBoxWidth - Math.floor(vm.topBoxWidth / COL_WIDTH) * COL_WIDTH;
         * 4、计算总的偏移量 vm.totalLeft = vm.d.pListStyle.width - COL_WIDTH * Math.floor(vm.topBoxWidth / COL_WIDTH) - mistakeWidth;
         * 5、设置偏移量 vm.left = Math.floor(vm.topBoxWidth / COL_WIDTH) * COL_WIDTH;
         * 6、vm.left === 0 时 左侧按钮不可点击
         * 7、vm.left === (-vm.totalLeft) 时 右侧按钮不可点击
         */


        /**
         * 设置banner图left
         * @param option
         */
        function setPListLeft(option) {
            if (option === 'next' && !vm.isAbleClick.next) {
                return;
            }

            if (option === 'prev' && !vm.isAbleClick.prev) {
                return;
            }

            setBtnStatus(true, true);

            vm.left = option === 'next' ? (vm.left - COL_WIDTH * num) : (vm.left + COL_WIDTH * num);
            if (vm.left > 0) {
                vm.left = 0;
                setBtnStatus(false, true);
            }
            if (-vm.left > vm.totalLeft) {
                vm.left = 0 - vm.totalLeft;
                setBtnStatus(true, false);
            }
            vm.d.pListStyle.transform = 'translateX(' + vm.left + 'px)';
        }

        function setBtnStatus(prev, next) {
            vm.isAbleClick.prev = prev;
            vm.isAbleClick.next = next;
        }

        /**
         * 生成随机数
         * @param max
         * @returns {number}
         */
        function randomNumber(max) {
            return Math.round(Math.random() * max);
        }

        /**
         * 获得country的value组成的数组
         */
        function handleCountryList() {
            for (var i = 0, len = COUNTRYS.length; i < len; i++) {
                countryValueList.push(COUNTRYS[i].value);
            }
        }

        /**
         * 随机生成3个不同的country
         * @param country
         * @returns {Array|*}
         */
        function randomThreeCountry(country) {
            country = country || [];
            var len = country.length;
            for (var i = 0; i < 3 - len; i++) {
                country.push(countryValueList[randomNumber(countryValueList.length - 1)]);
            }
            country = arrayGoHeavy(country);
            if (country.length === 3) {
                return country;
            } else {
                randomThreeCountry(country);
            }
        }

        /**
         * 数组去重
         * @param arr
         * @returns {Array}
         */
        function arrayGoHeavy(arr) {
            var res = [];
            var json = {};
            for (var i = 0; i < arr.length; i++) {
                if (!json[arr[i]]) {
                    res.push(arr[i]);
                    json[arr[i]] = 1;
                }
            }
            return res;
        }

        function gotoStore(id) {
            window.open('/pop-store?m=NO_C&storeId=' + id);
        }

    }


})();
